import { render, staticRenderFns } from "./Autoresponders.vue?vue&type=template&id=3bfc5dee"
import script from "./Autoresponders.vue?vue&type=script&lang=js"
export * from "./Autoresponders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports